"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
const styles = new Proxy({"OurTeam":"OurTeam-eac97","OurTeamContainer":"OurTeamContainer-eac97","OurTeamImg":"OurTeamImg-eac97","CarouselWrap":"CarouselWrap-eac97","SlideOuter":"SlideOuter-eac97","Controls":"Controls-eac97","Dots":"Dots-eac97","Dot":"Dot-eac97","DotActive":"DotActive-eac97","ArrowBtn":"ArrowBtn-eac97","SectionTitle":"SectionTitle-eac97"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./KinervaOurTeamSlider.scss";*/

const IMAGES = [
  { src: "/images/cursor_insight.jpg", borderRadius: "0px 0px 50px 0px" },
  { src: "/images/CI_evezes.jpg",       borderRadius: "0px 0px 0px 50px" },
  { src: "/images/gang.jpg",            borderRadius: "0px 50px 0px 0px" },
  { src: "/images/lounge.jpg",          borderRadius: "50px 0px 0px 0px" },
];

export default function KinervaOurTeamCarousel() {
  const sliderRef = useRef<Slider>(null);
  const [active, setActive] = useState(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const check = () => setActive(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!active) return null;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider ref={sliderRef} {...SETTINGS} className="KinervaOurTeamSlider">
        {IMAGES.map((img, idx) => (
          <div key={idx} className={styles.SlideOuter}>
            <div
              className={styles.OurTeamImg}
              style={{ borderRadius: img.borderRadius }}
            >
              <img src={img.src} alt="" />
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.Controls}>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <Image src={arrowLeft} alt="Previous" width={20} height={29} />
        </button>
        <ul className={styles.Dots}>
          {IMAGES.map((_, i) => (
            <li
              key={i}
              className={i === current % IMAGES.length ? styles.DotActive : styles.Dot}
              onClick={() => sliderRef.current?.slickGoTo(i)}
            />
          ))}
        </ul>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <Image src={arrowRight} alt="Next" width={20} height={29} />
        </button>
      </div>
    </div>
  );
}
